import LabRepository from "./LabRepository";

const resource = "/result-export";

export default {
  getAll(params) {
    return LabRepository.get(`${resource}?limit=all`, { params });
  },
  get(id, params) {
    return LabRepository.get(`${resource}/${id}`, { params });
  },
  create(payload) {
    return LabRepository.post(resource, payload);
  },
  download(id) {
    return LabRepository.get(`${resource}/${id}/download`);
  },
};
